<template>
	<teleport to="body">
		<transition name="backdrop" appear>
			<div class="backdrop" @click="closeDialog" v-if="open"></div>
		</transition>
		<transition name="modal" appear>
			<dialog open v-if="open" @keydown.esc="closeDialog" class="vehicle-picker-modal__panel vehicle-picker-modal__panel--active">
				<div class="vehicle-picker-modal__title card-title">
					Select Vehicle
				</div>
        <div class="vehicle-picker-modal__text">
            Select a vehicle to find exact fit parts
        </div>
        <saved-vehicles @cancel-saved-vehicles="closeDialog" @closePanel="$emit('close')"></saved-vehicles>
			</dialog>
		</transition>
	</teleport>
</template>

<script>
import SavedVehicles from '../common/vehicle/SavedVehicles';

export default {
    components: {
        "saved-vehicles": SavedVehicles,
    },
	props: {
		open: {
			type: Boolean,
			required: true,
			default: false
		}
	},
	emits: [ 'close' ],
    methods: {
        closeDialog() {
            this.$emit('close');
        }
    }
}
</script>

<style scoped>
.vehicle-picker-modal__panel {
	max-width: 500px;
}

dialog {
  border: 0;
  box-shadow: 0 5px 5px rgba(0, 0, 0, 0.2);
  position: absolute;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  margin: auto;
  width: fit-content;
  height: fit-content;
  padding: 2rem;
  background: #FFF;
  z-index: 1001;
  transform: none;
}

header {
  position: relative;
}

header .card-title {
  min-height: 45px;
}

header .dialog-close {
  height: 40px;
  position: absolute;
  right: 0;
  top: 0;
  width: 40px;
}

header .dialog-close:before, 
header .dialog-close:after {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 2px;
    height: 15px;
    background-color: #2c3e50;
    transform: rotate(45deg) translate(-50%, -50%);
    transform-origin: top left;
    transition: all 420ms;
    content: '';
}

header .dialog-close:after {
    transform: rotate(-45deg) translate(-50%, -50%);
}

.backdrop {
  content: '';
  position: absolute;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1000;
  background: rgba(51, 51, 51, 0.8);
  opacity: 0.6;
  cursor: pointer;
}

.backdrop-enter-active {
  animation: backdrop ease .4s;
}

.backdrop-leave-active {
  animation: backdrop ease .4s reverse;
}

@keyframes backdrop {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 0.6;
  }
}

.modal-enter-active {
  animation: modal 0.3s ease-out;
}

.modal-leave-active {
  animation: modal 0.3s ease-in reverse;
}

@keyframes modal {
  from {
    opacity: 0;
    transform: translateY(-50px) scale(0.9);
  }

  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

.actions {
  display: flex;
  -webkit-box-pack: end;
  justify-content: flex-end;
  margin-top: 2rem;
  text-align: right;
}

[dir=ltr] .actions > *:not(:last-child) {
  margin-right: 12px;
}

</style>